import atTheFunctionBanner from "@src/assets/images/AtTheFunctionBanner.png";

export const dropContent = {
  title: "PRJKT2700 | AT THE FUNCTION",
  description: "Featuring art from: Tetra, MADWORLD, Braavi, Juan, Dove",
  image: atTheFunctionBanner,
};
